import updateSearchQueries from "./update-search-queries";

export default updateSearchQueries;
